import axios from 'axios';

const baseURL = 'api/Contestacion';


async function setGuardarContestacion(contestacionAGuardar) {
    const { data } = await axios.post(baseURL, contestacionAGuardar);
    return data;
}

async function getPreguntaAnterior(user, idPregunta, idEje) {
    const { data } = await axios.get(baseURL + '/anterior?idUsuario=' + user.id + '&idPregunta=' + idPregunta + '&idEje=' + idEje + '&language=' + user.language,
    {
        headers: {
            'token': user.token
        }
    }
    );
    return data
}

async function reiniciarEje(usuario, idEje) {
    const { data } = await axios.delete(baseURL + "/reiniciarEje?idUsuario=" + usuario.id +"&idEje="+ idEje +"&language=" + usuario.language,
        {
            headers: {
                'token': usuario.token
            }
        }
    );
    return data;
}

export default { setGuardarContestacion, getPreguntaAnterior, reiniciarEje };